/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!************************************!*\
  !*** ./src/assets/js/quick-add.js ***!
  \************************************/
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(fn) { try { return Function.toString.call(fn).indexOf("[native code]") !== -1; } catch (e) { return typeof fn === "function"; } }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var ProductCard = /*#__PURE__*/function (_HTMLElement) {
  function ProductCard() {
    var _this;
    _classCallCheck(this, ProductCard);
    _this = _callSuper(this, ProductCard);
    _this.forms = _this.querySelectorAll('.product-card__quick-buy form');
    _this.increaseBtn = _this.querySelectorAll('line-item-quantity .increase-qty');
    _this.decreaseBtn = _this.querySelectorAll('line-item-quantity .decrease-qty');
    return _this;
  }
  _inherits(ProductCard, _HTMLElement);
  return _createClass(ProductCard, [{
    key: "fetchCart",
    value: function () {
      var _fetchCart = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", fetch('/cart.js').then(function (response) {
                return response.json();
              })["catch"](function (error) {
                return console.error('Error fetching cart:', error);
              }));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function fetchCart() {
        return _fetchCart.apply(this, arguments);
      }
      return fetchCart;
    }()
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      this.initializeEventListeners();
      this.fetchCart().then(function (cart) {
        _this2.updateCartData(cart);
      });
    }
  }, {
    key: "initializeEventListeners",
    value: function initializeEventListeners() {
      var _this3 = this;
      this.forms.forEach(function (form) {
        form.addEventListener('submit', _this3.handleSubmit);
      });
      this.increaseBtn.forEach(function (button) {
        button.addEventListener('click', _this3.handleQuantityClick);
      });
      this.decreaseBtn.forEach(function (button) {
        button.addEventListener('click', _this3.handleQuantityClick);
      });
      eventBus.addEventListener('quantityChange', this.updateQuantity);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      var _this4 = this;
      tthis.forms.forEach(function (form) {
        form.removeEventListener('submit', _this4.handleSubmit);
      });
      this.increaseBtn.forEach(function (button) {
        button.removeEventListener('click', _this4.handleQuantityClick);
      });
      this.decreaseBtn.forEach(function (button) {
        button.removeEventListener('click', _this4.handleQuantityClick);
      });
    }
  }, {
    key: "updateCartData",
    value: function updateCartData(cart) {
      var productId = this.getAttribute('data-product-id');
      var cartItem = cart.items.find(function (item) {
        return item.id == productId;
      });
      if (cartItem) {
        this.querySelectorAll('button[type="submit"]').forEach(function (button) {
          button.style.display = 'none';
        });
        var quantitySelector = this.querySelector('line-item-quantity');
        if (quantitySelector) {
          quantitySelector.classList.remove('hide');
          quantitySelector.querySelector('input').value = cartItem.quantity;
        }
      }
    }
  }, {
    key: "resetAddToCartButton",
    value: function resetAddToCartButton(item) {
      item.querySelector('button[type="submit"]').style.display = 'block';
      var quantitySelector = item.querySelector('line-item-quantity');
      if (quantitySelector) {
        quantitySelector.classList.add('hide');
      }
    }
  }, {
    key: "updateQuantity",
    value: function updateQuantity(event) {
      var _event$detail = event.detail,
        productId = _event$detail.productId,
        quantity = _event$detail.quantity;
      var items = document.querySelectorAll("main product-card[data-product-id=\"".concat(productId, "\"]"));
      items.forEach(function (item) {
        var itemQty = item.querySelector('line-item-quantity');
        if (itemQty.classList.contains('hide')) {
          item.querySelectorAll('button[type="submit"]').forEach(function (button) {
            button.style.display = 'none';
          });
          var quantitySelector = item.querySelector('line-item-quantity');
          if (quantitySelector) {
            quantitySelector.classList.remove('hide');
            quantitySelector.querySelector('input').value = quantity;
          }
        } else {
          var input = item.querySelector('line-item-quantity .quantity-input');
          input.value = quantity;
          if (quantity === 0) {
            item.querySelectorAll('button[type="submit"]').forEach(function (button) {
              button.style.display = 'block';
            });
            var _quantitySelector = item.querySelector('line-item-quantity');
            if (_quantitySelector) {
              _quantitySelector.classList.add('hide');
            }
          }
        }
      });
    }
  }, {
    key: "refreshCart",
    value: function refreshCart() {
      fetch(window.location.href).then(function (response) {
        return response.text();
      }).then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        document.querySelector('sticky-cart').innerHTML = doc.querySelector('sticky-cart').innerHTML;
      })["catch"](function (err) {
        console.warn('Something went wrong.', err);
      });
    }
    /*
      handleSubmit(event) {
        
        event.preventDefault();
        const form = event.target;
        const parent = form.parentElement;
        const productId = form.querySelector('input[name="id"]').value;
        const productType = form.quantitySelector('input[name="product_type"]').value;
        let updates = {
          [productId]: 1
        };
        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            updates
          }),
        })
        .then(response => {
          if (!response.ok) {
            return response.json().then(err => Promise.reject(err));
          }
          return response.json();
        })
        .then(data => {
          if ( parent.classList.contains('upsell-product__cta') && !parent.classList.contains('toggle-drawer')){
            console.log('upsell product');
            emitQuantityChange(null, productId, 1, productType, true);
          } else {
            console.log('open drawer');
            emitQuantityChange(null, productId, 1, productType);
          }
        })
        .catch(error => {
          console.error('Error:', error);
        });
      }*/
  }, {
    key: "handleSubmit",
    value: (function () {
      var _handleSubmit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(event) {
        var form, parent, productId, productType, updates, showModal, response, cart, currentProductTypes, differentTypeExists, data;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              event.preventDefault();
              form = event.target;
              parent = form.parentElement;
              productId = form.querySelector('input[name="id"]').value;
              productType = form.querySelector('input[name="product_type"]').value;
              updates = _defineProperty({}, productId, 1);
              showModal = function showModal() {
                var modal = document.getElementById('cart-message-modal');
                var okButton = document.getElementById('modal-ok-button');
                modal.style.display = 'block';
                okButton.addEventListener('click', function () {
                  modal.style.display = 'none';
                });
              };
              _context2.prev = 7;
              _context2.next = 10;
              return fetch('/cart.js');
            case 10:
              response = _context2.sent;
              if (response.ok) {
                _context2.next = 15;
                break;
              }
              _context2.next = 14;
              return response.json();
            case 14:
              throw _context2.sent;
            case 15:
              _context2.next = 17;
              return response.json();
            case 17:
              cart = _context2.sent;
              if (!(cart.items.length > 0)) {
                _context2.next = 31;
                break;
              }
              // Get the types of products currently in the cart
              currentProductTypes = cart.items.map(function (item) {
                return item.product_type;
              }); // Check if there are different types in the cart
              differentTypeExists = currentProductTypes.some(function (type) {
                return type !== productType;
              });
              if (!differentTypeExists) {
                _context2.next = 31;
                break;
              }
              _context2.next = 24;
              return fetch('/cart/clear.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                }
              });
            case 24:
              response = _context2.sent;
              if (response.ok) {
                _context2.next = 29;
                break;
              }
              _context2.next = 28;
              return response.json();
            case 28:
              throw _context2.sent;
            case 29:
              console.log('Cart cleared');
              showModal();
            case 31:
              _context2.next = 33;
              return fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  updates: updates
                })
              });
            case 33:
              response = _context2.sent;
              if (response.ok) {
                _context2.next = 38;
                break;
              }
              _context2.next = 37;
              return response.json();
            case 37:
              throw _context2.sent;
            case 38:
              _context2.next = 40;
              return response.json();
            case 40:
              data = _context2.sent;
              if (parent.classList.contains('upsell-product__cta') && !parent.classList.contains('toggle-drawer')) {
                console.log('upsell product');
                emitQuantityChange(null, productId, 1, productType, true);
              } else {
                console.log('open drawer');
                emitQuantityChange(null, productId, 1, productType);
              }
              _context2.next = 47;
              break;
            case 44:
              _context2.prev = 44;
              _context2.t0 = _context2["catch"](7);
              console.error('Error:', _context2.t0);
            case 47:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[7, 44]]);
      }));
      function handleSubmit(_x) {
        return _handleSubmit.apply(this, arguments);
      }
      return handleSubmit;
    }())
  }, {
    key: "showMessage",
    value: function showMessage() {
      var allMsgs = document.querySelectorAll('.cart-type-msg');
      allMsgs.forEach(function (msg) {
        msg.classList.remove('tw-hidden');
      });
    }
  }, {
    key: "handleQuantityClick",
    value: function handleQuantityClick(event) {
      var button = event.target;
      var input = button.parentElement.querySelector('input');
      var parent = button.parentElement;
      var quantity = parseInt(input.value);
      if (button.classList.contains('increase-qty')) {
        quantity += 1;
      } else {
        quantity -= 1;
      }
      var productId = button.getAttribute('data-variant-id');
      parent.classList.add('loading');
      parent.setAttribute('disabled', true);
      var updates = _defineProperty({}, productId, quantity);
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          updates: updates
        })
      }).then(function (response) {
        if (!response.ok) {
          return response.json().then(function (err) {
            return Promise.reject(err);
          });
        }
        return response.json();
      }).then(function (data) {
        emitQuantityChange(null, productId, quantity);
      })["catch"](function (error) {
        console.error('Error:', error);
      })["finally"](function () {
        parent.classList.remove('loading');
        parent.setAttribute('disabled', false);
      });
    }
  }]);
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('product-card') && document.querySelector('product-card')) {
  customElements.define('product-card', ProductCard);
}
/******/ })()
;